<template>
  <el-aside width="18%" style="height: 100%">
    <div class="company-head flex" style="flex-direction: column; justify-content: center">
      <span class="company-head-name ml20">{{ $store.state.user.company.cName || '未命名' }}</span>
      <div class="company-head-name ml20" style="font-size: 12px; font-weight: normal">
        <span>入网时间:</span>
        <span>{{ compinfo.c_in_net }}</span>
      </div>
    </div>
    <!-- <div class="company-info-cont mt10" style="border-bottom:2px solid #E4E4E4;width:96%">
      <div class="lwcompany-info-head">
        <div class="ml20"><i class="el-icon-office-building"></i><span class="ml10">单位信息</span></div>
      </div>
    <div class="unite-message-body ml20" style="margin-bottom:10px ">
          <div class="unite-message-content mt10"  >
            <ul>
              <li>
                <span class="unite-message-content-head">单位编号:</span>
                <span class="unite-message-content-end" :title=" '' ">{{
                  unitInfo.c_name || "啊啊啊  "
                }}</span>
              </li>
                <li>
                <span class="unite-message-content-head">单位地址:</span>
                <span class="unite-message-content-end" :title=" '' ">{{
                  unitInfo.c_name || "啊啊啊爱仕达啊啊啊啊 "
                }}</span>
              </li>
                <li>
                <span class="unite-message-content-head">单位电话:</span>
                <span class="unite-message-content-end" :title=" '' ">{{
                  unitInfo.c_name || "啊啊啊爱仕达大 "
                }}</span>
              </li>
                <li>
                <span class="unite-message-content-head">入网时间:</span>
                <span class="unite-message-content-end" :title=" '' ">{{
                  unitInfo.c_name || "啊啊啊爱仕达大 "
                }}</span>
              </li>
            </ul>
          </div>
    </div>
    </div> -->
    <div class="device-cont mt20" style="margin-top: 40px">
      <div class="lwcompany-info-head flex" style="justify-content: space-between">
        <div class="ml20"><i class="el-icon-s-marketing"></i><span class="ml10">设备在线状态统计</span></div>
        <div class="cursor" style="margin-right: 20px" @click="showstatic = true"><span>更多</span><i class="el-icon-arrow-right"></i></div>
      </div>
      <div class="device-cont flex center" style="flex-direction: column">
        <div class="mt20 sum flex1">设备数量:{{ devicesum }}</div>

        <div class="tab1" id="tab1"></div>
      </div>
    </div>
    <el-menu class="el-menu-vertical-demo mt20" @open="handleOpen" style="border-right: none;height:380px;overflow:auto" @close="handleClose">
      <el-menu-item class="el-submenu__title ml10" index="0" @click="showMoreList = true">
        <i class="el-icon-document" style="color: #8994a9"></i>
        <span slot="title" class="" style="color: #8994a9">火警记录</span>
      </el-menu-item>
      <!-- <el-submenu
        :index="String(index)"
        v-for="(nav, index) in permission.addRoutes"
        :key="index"
         v-if="nav.meta && nav.meta.title"
      >
        <template slot="title">
          <p class="ml10">
            <i :class="nav.func_tag || 'el-icon-folder'" slot="icon"></i>
            <span>{{    nav.meta ? nav.meta.title : '' }}</span>
          </p>
        </template>

        <div class="ml20 menu" style="margin-left: 30px">
          <el-steps direction="vertical" space="30px">
            <el-step
              v-for="child in nav.children"

              @click.native="linkto(child)"
              :title=" child.meta.title"
            >
              <i class="" slot="icon"></i>{{ child.meta.title }}</el-step
            >
          </el-steps>
        </div>
      </el-submenu> -->
      <!-- <el-menu-item class="el-submenu__title ml10" :index="String(navList.length + 1)" @click="gocom" v-if="!$store.state.user.userInfo.tongxin">
        <i class="el-icon-document" style="color: #8994a9"></i>
        <span slot="title" class="" style="color: #8994a9">访问官网</span>
      </el-menu-item> -->
      <el-menu-item class="el-submenu__title ml10" :index="String(navList.length + 2)" @click="changePass">
        <i class="el-icon-document" style="color: #8994a9"></i>
        <span slot="title" class="" style="color: #8994a9">修改密码</span>
      </el-menu-item>
      <el-tooltip v-if="lateDate" :hide-after="5000" :content="`消防设施存在到期情况,\r请尽快处理!!`" popper-class="dayLate" placement="bottom">
        <router-link :to="{ path: '/fireFacilitiesManage' }">
          <el-menu-item class="el-submenu__title ml10" :index="String(navList.length + 3)">
            <i class="el-icon-bell noticeAnimate" style="color:#fff;background:red;border-radius:50%;height:22px;width:22px;padding-top:1px"></i>
            <span slot="title" class="" style="color: #8994a9">设施到期提醒</span>
          </el-menu-item>
        </router-link>
      </el-tooltip>
    </el-menu>
    <el-dialog :visible.sync="showstatic" width="90%" title="设备实时状态" :show-close="true">
      <device :c_number="$store.state.user.company.cCompanyNum"></device>
    </el-dialog>
    <el-dialog :visible.sync="showMoreList" width="100%" :show-close="false">
      <div slot="title" class="dialog-header">
        <div class="d-title flex1" style="position: relative">
          <i class="icon-tr-Real-time-alarm" style="padding-right: 5px"></i>
          <span style="color: white">历史报警信息</span>
          <!-- <div class="btn" @click="$store.commit('swithWaring',0)" v-show="isWaring" style="position:absolute;right:0;top:-5px" >
            <span>关闭此次警报</span>
          </div> -->
        </div>

        <div class="d-right align-center">
          <!-- <div class="btn" @click="$store.commit('swtichLoop')">
            <span>{{isLoop?'长鸣':'只响一次'}}</span>
          </div>
          <span
            :class="`icon-tr-${isMute?'mute':'voice'} ml20`"
            @click="$store.commit('switchMute')"
          ></span> -->
          <span class="icon-tr-Close ml20" @click="showMoreList = false"></span>
        </div>
      </div>
      <div style="overflow: auto; height: 300px;">
        <div class="ml20 flex searchform">
          <fm-generate-form :data="histsearch" ref="histsearch"></fm-generate-form>
          <div style="inline" class="ml10">
            <span class="ml10">报警类型:</span>
            <el-select v-model="listParams.evenClass" @change="changeType" size="small" class="ml10">
              <el-option v-for="item in Object.values(this.$map.bjStatus)" :key="item" :value="item">{{ item }}</el-option>
            </el-select>
          </div>
          <div class="">
            <el-button type="primary ml20" @click="searchsub" size="small">查询</el-button>
            <el-button type=" ml20" @click="resetSearch" size="small">重置</el-button>
          </div>
        </div>
        <table class="hj-message-table" style="width: 100%">
          <thead>
            <tr>
              <!-- <th>处理</th> -->
              <th>单位名称</th>
              <th style="width: 200px">报警时间</th>
              <!--                        <th>测试</th>-->
              <th>报警类型</th>
              <th width="130px">联系电话</th>
              <!--                        <th>节点</th>-->
              <th>设备类型</th>
              <th>报警节点</th>
              <th>报警地点</th>
              <th style="width: 5%">报警点位</th>

              <!--                        <th>点位图</th>-->
            </tr>
          </thead>
          <tbody class="tr_context_box">
            <tr v-for="(item, index) in companyInfo" :key="index">
              <td>{{ item.company }}</td>
              <td>{{ item.nowtime }}</td>
              <td>{{ item.evenClass }}</td>
              <td>{{ item.phone }}</td>
              <td :title="item.deviceType">{{ item.deviceType }}</td>
              <td :title="item.detailAddr">{{ item.detailAddr }}</td>
              <td :title="item.detailAddr">{{ item.msgDescribe }}</td>

              <td>
                <a title="查看点位" class="cursor" @click="openPoint(item)" style="color: #4A9DFF">查看点位</a>
              </td>
            </tr>
          </tbody>
          <el-pagination
            background
            v-if="companyInfoCount > 10"
            layout="prev, pager, next"
            :page-size="listParams.limit || 10"
            @current-change="pageChange"
            :total="companyInfoCount"
            :current-page.sync="listParams.page"
          >
          </el-pagination>
        </table>

        <p class="mt20 tx-center" v-show="companyInfo.length == 0">没有更多</p>
      </div>
    </el-dialog>
    <el-dialog title="查看点位信息" width="80%" :visible.sync="crtpoint">
      <crtmark :compnum="crtcompany" refs="crtmark"></crtmark>
    </el-dialog>

    <el-dialog title="修改密码" :visible.sync="showDia" width="500px" :append-to-body="true" :close-on-click-modal="false">
      <el-form ref="passForm" :model="passForm" label-width="110px">
        <!-- <el-form-item label="请输入旧密码" prop="old">
                    <el-input placeholder="请输入旧密码" v-model="passForm.old" show-password></el-input>
                </el-form-item> -->
        <el-form-item label="请输入旧密码" prop="old_password">
          <el-input placeholder="请输入旧密码" v-model="passForm.old_pwd" show-password></el-input>
        </el-form-item>
        <el-form-item label="请输入新密码" prop="new_password">
          <el-input placeholder="请输入新密码" v-model="passForm.new_pwd" show-password></el-input>
        </el-form-item>
        <el-form-item label="请确认密码" prop="new_confirm">
          <el-input placeholder="请确认密码" v-model="passForm.confirm" show-password></el-input>
        </el-form-item>
      </el-form>
      <div class="center mt20">
        <el-button type="primary" @click="passSubmit" size="small">提交</el-button>
        <el-button @click="resetchange(true)" size="small">取消</el-button>
      </div>
    </el-dialog>
  </el-aside>
</template>

<script>
import echarts from 'echarts';
import device from './online-static';
import { getTime } from '@/api/common.js';
import crtmark from '@/components/crtpoints.vue';
import { mapState } from 'vuex';

export default {
  components: {
    device,
    crtmark,
  },
  computed: {
    ...mapState(['permission']),
  },
  watch: {
    // "$route.path"(val, old) {
    //   if (this.navList.length) {
    //     this.checkRouter(val);
    //   }
    // },
    crtpoint(val) {
      if (!val) {
        this.$refs['crtmark'].reset();
      }
    },
  },
  data() {
    return {
      histsearch: this.$getForm('historysearch'),
      companyInfo: [],
      showDia: false,
      passForm: {
        old_pwd: '',
        new_pwd: '',
        confirm: '',
      },
      isCollapse: true,
      lateDate: false,
      navList: [],
      showstatic: false,
      key: 'kkk', // this.$local.get('user').key,
      open: [],
      devicesum: 0,
      menuList: [],
      crtpoint: false,
      allList: [],
      unitInfo: {},
      compinfo: {},
      crtcompany: {},
      showMoreList: false,
      listParams: {
        page: 1,
        limit: 10,
        c_company_num: this.$store.state.user.company.cCompanyNum,
        maxPage: 2,
        type: '火警',
        evenClass: '火警',
        company: '',
      },
      companyInfoCount: 0,
    };
  },
  created() {
    this.getMenu();
    this.getList();
    this.getHistory(this.listParams);
    // 设施到期提醒
  },
  mounted() {
    this.makeChart();
  },
  methods: {
    changePass() {
      this.showDia = true;
    },
    changeType(val) {
      this.listParams.page = 1;
    },
    passSubmit() {
      console.log(this.passForm);
      var { old_pwd, new_pwd, confirm } = this.passForm;
      if (!old_pwd || !new_pwd || !confirm) {
        this.$message.error('请填写必填信息');
        return false;
      } else if (confirm !== new_pwd) {
        this.$message.error('输入的两次密码不相同');
        return false;
      } else if (old_pwd === new_pwd) {
        this.$message.error('新密码不可以与旧密码相同');
        return false;
      }

      this.$post('/user/xiugaimima', this.passForm).then((res) => {
        this.$message({message: res.msg,type: "success", duration: 700,});
        this.resetchange();
        this.showDia = false;

        setTimeout(() => {
          this.$store.commit('clearUser');

          this.$router.replace({
            path: '/login',
          });
        }, 1400);
      });
    },
    resetchange(a) {
      this.passForm = { old_pwd: '', new_pwd: '', confirm: '' };
      if (a) {
        this.showDia = false;
      }
    },

    chaneNum(v) {
      var str = Number(v) <= 9 ? `0${v}` : v;
      return str;
    },
    // crt点位
    openPoint(it) {
      this.crtcompany = { c_number: it.c_company_num, number: it.detailAddr };
      this.crtpoint = true;
    },
    // gopage() {
    //   var date = new Date();
    //   var time = `${date.getFullYear()}-${this.chaneNum(date.getMonth() + 1)}-${date.getDate()}`;
    //   var obj = { user: this.$local.get("account").username, time };
    //   this.$post("/website/automaticlogin", obj).then((res) => {
    //     window.open(`http://www.tongren119.com?info=${res}`, "_blank");
    //   });
    // },
    // 跳入官网
    gocom() {
      window.open('https://www.tongren119.com/');
    },

    // checkRouter(val) {
    //   // if (this.$store.state.isDev) {
    //   //   return;
    //   // }
    //   if (this.$store.state.userInfo.role !== 0) {
    //     return;
    //   }
    //   // console.log(this.menuList)

    //   // console.log(this.allList)
    //   if (
    //     this.menuList.indexOf(val.substr(1)) === -1 &&
    //     this.allList.indexOf(val.substr(1)) > -1
    //   ) {
    //     if (this.$route.path !== "/404" && this.$route.path !== "/") {
    //       this.$router.replace("/404");
    //     }
    //   }
    // },

    searchsub() {
      this.$refs.histsearch
        .getData()
        .then((data) => {
          this.listParams = { ...this.listParams, ...data };
          this.listParams.type = this.listParams.evenClass;
          // return
          if (!this.listParams.starttime || !this.listParams.endtime) {
            this.getHistory(this.listParams);
          } else {
            this.getInfoList(this.listParams, true);
          }

          // this.showDia = false;
          this.listParams.page = 1;
          this.changeType();
        })
        .catch((e) => {});
    },
    resetSearch() {
      this.$refs.histsearch.reset();
      var params = { ...this.listParams, ...this.$refs.histsearch.models };
      this.getHistory(params);
    },
    pageChange(val) {
      // console.log(val)
      this.listParams.page = val;

      this.getInfoList(this.listParams);
      // this.listParams.page = 1;
    },
    getHistory(PAR) {
      // getTime().then((data) => {
      //   let time = data.sysTime2.replace(/-/g, "/");
      //   let timeLine = new Date(time).getTime();
      //   PAR.starttime = new Date(timeLine).Format("yy年MM月dd日 00:00:00");
      //   PAR.endtime = new Date(timeLine).Format("yy年MM月dd日 23:59:59");
      // });

      // console.log()
      let time = new Date(+new Date() + 8 * 3600 * 1000)
        .toJSON()
        .substr(0, 19)
        .replace('T', ' ')
        .replace(/-/g, '/');
      let timeLine = new Date(time).getTime();
      PAR.starttime = new Date(timeLine).Format('yyyy年MM月dd日 00:00:00');
      PAR.endtime = new Date(timeLine).Format('yyyy年MM月dd日 23:59:59');
      this.getInfoList(PAR);
    },

    getInfoList(params, isTrue) {
      var today = false;
      var starttime = params.starttime.substring(0, params.starttime.indexOf(' '));
      var endtime = params.endtime.substring(0, params.starttime.indexOf(' '));
      // var nowtime = this.$local.get("nowtime");
      var nowtime = this.$local.get('nowtime').substring(0, this.$local.get('nowtime').indexOf(' '));

      // nowtime = nowtime.substring(0, nowtime.indexOf(" "));
      if (nowtime === starttime && nowtime === endtime) {
        today = true;
      }
      // console.log(today)

      var url = today ? 'leftview/viewInfoBottom' : '/demarcate/donotdodata';
      this.$post(url, params).then((res) => {
        //this.companyInfo = res.data.list
        this.$set(this, 'companyInfo', res.data.list);
        this.companyInfoCount = res.data.count;
      });
      this.listParams = params;
    },
    // getNowTime(params){
    //   this.$post('leftview/viewInfoBottom',params)
    // },
    getMenu() {
      // this.$post("/menu/thisusermenu").then((res) => {
      //   this.navList = res.data;
      //   for (let key in this.navList) {
      //     this.menuList.push(this.navList[key].menu_href);
      //     if (this.navList[key].tr_power_hson) {
      //       this.navList[key].tr_power_hson.forEach((menu) => {
      //         this.menuList.push(menu.menu_href);
      //       });
      //     }
      //   }
      // });
      // this.$post("/menu/findall", { page: 1, limit: 100 }).then((res) => {
      //   // console.log(res.data)
      //   let arr1 = res.data.list;
      //   for (let key in arr1) {
      //     this.allList.push(arr1[key].menu_href);
      //   }
      //   this.checkRouter(this.$route.path);
      // });
      this.$post('/monitor/devicestatesone').then((res) => {
        var arr = [];
        arr.push({
          value: res.data.device.length - res.data.device_size,
          name: '离线',
        });
        arr.push({ value: res.data.device_size, name: '在线' });
        this.devicesum = res.data.device.length;
        this.makeChart(arr);
      });

      // console.log(this.$store.state.userInfo )
      this.$get('/trmoni/fireFacilitiesManage/policeButton', { companyId: this.$store.state.user.company.cCompanyNum }).then((res) => {
        // console.log(res, 'get status');
        this.lateDate = res.data;
      });
    },
    getList() {
      this.$post('/demarcate/allcompanyshowsfire').then((res) => {
        this.$store.commit('SAVECOMP', res.data.company);
      });
      this.$post('/devicemanage/basesdetail', {
        c_company_num: this.$store.state.user.company.cCompanyNum,
      }).then((res) => {
        this.compinfo = res.data;
      });
    },
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {},
    linkto(it) {
      this.$router.push(it.path);
    },
    //饼图设备状态

    makeChart(arr) {
      // if (arr.length == 0) {
      //   arr.push({ value: 0, name: "暂无数据" });
      // }
      let option = {
        label: {
          normal: {
            show: false,
          },
        },
        title: {
          left: 'center',
          top: '0px',
          textStyle: {
            fontSize: 14,
          },
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)',
        },
        legend: {
          orient: 'vertical',
          top: '30px',
          right: '20px',
          data: ['离线', '在线'],
          textStyle: {
            fontStyle: 'normal',
            fontSize: 12,
          },
        },
        series: [
          {
            name: '',
            title: '访问来源',
            type: 'pie',
            radius: '70%',
            center: ['35%', '40%'],
            data: arr,
            color: ['#FFB800', '#00BC8B'],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
            label: {
              show: false,
            },
          },
        ],
      };
      echarts.init(document.getElementById('tab1')).setOption(option);
    },
  },
};
</script>

<style lang="scss" scoped>
.noticeAnimate {
  animation: warningmove 0.6s infinite;
}
@keyframes warningmove {
  from {
    background: yellow;
    color: red;
  }
  to {
    background: red;
    color: white;
  }
}

::v-deep .menu .el-step__title {
  font-size: 13px !important;
  cursor: pointer;
}

// ::v-deep .el-tooltip__popper {
//     background: #FBDCE0 !important;
//     border: 1px solid #FDB5BE !important;
// }

.dayLate {
  background: red !important;
}
.menu {
  max-height: 200px;
  overflow: auto;
}
.sum {
  font-weight: 900;
  width: 100%;
  margin-left: 40px;
  text-align: left;
}
::v-deep .el-step__icon {
  position: relative;
  z-index: 1;
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 8px;
  height: 8px;
  left: 8px;
  bottom: 5px;
  background: #c0c4cc;
  font-size: 13px;
  box-sizing: border-box;
  transition: 0.15s ease-out;
}
::v-deep .el-submenu__title {
  height: 35px;
  line-height: 35px;
  font-size: 14px;
  color: #8994a9;
  padding: 0 20px;
  list-style: none;
  cursor: pointer;
  position: relative;
  transition: border-color 0.3s, background-color 0.3s, color 0.3s;
  box-sizing: border-box;
  white-space: nowrap;
}
.step {
  height: 100%;
  width: 100%;
  border-radius: 50%;
  background: #c0c4cc;
  border: none;
}

.el-menu-verti cal-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}
.home-menu {
  margin-top: 40px;
}
.company-head {
  // height: 60px;
  margin-top: 5px;
  padding: 10px 0 10px;
  border-radius: 0 50px 50px 0;
  width: 88%;
  text-overflow: ellipsis;
  overflow: hidden;
  background: linear-gradient(to right, #d9f7fd, #e2e8fa);
}
/* 公司名 */

.company-head-name {
  font-size: 16px;
  color: #4a9dff;
  font-weight: 700;
}
/* 左侧导航栏 */
.lwcompany-info {
  font-size: 16px;
}

/* 左侧头部 */
.lwcompany-info-head {
  color: #4a9dff;
  font-size: 14px;
  font-weight: 400;
}
/* 信息内容 */
.unite-message-content {
  font-size: 12px;
  width: 83%;
  color: #8490a6;
  .unite-message-content-head {
    width: 30%;
  }
  .unite-message-content-end {
    width: 70%;
  }
  ul {
    li {
      display: flex;
      margin-top: 5px;
      span {
        display: inline-block;
      }
    }
  }
}
.tab1 {
  margin-top: 5px;
  height: 150px;
  width: 100%;
}
</style>
